<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UZFF4C/tc-custom/9781399064309.jpg?1733119498598" alt="This image is the cover for the book Sweating Sickness Epidemic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sweating Sickness Epidemic
      </h1>
      <p class="bookDescription body article font2">
        <p>Among the array of diseases which brought death to Tudor England, the sweating sickness stood out, for the speed with which it struck, its dreadful effects on its victims and the death rates which it produced, that together generated a fear verging on panic when it was identified. The sweating sickness attacked the cities, towns and the countryside, not sparing the palaces. It threatened everyone, from the king in his castle to the beggars at his gates, including members of the dynasty and the political structure, the courtiers and those who directed the government, the church and the law. Contemporaries could do little more than make a bolt for it, and that included the king and his closest advisors, who moved furtively in a small group from one house to another away from London. The principal epidemics came between 1485, when it made its first appearance, and 1551, and it was confined to England and Wales, apart from one major eruption across northern Europe in 1529. Known as the English disease, this rapidly acting virus became Henry VIII’s overriding fear, aggravating his well-known hypochondria and controlling his movements.  The nature of the sweating sickness, its incidence and impact are all examined in this book, in the context not only of Tudor England and the problems of the Henrician succession, but also in the context of epidemic disease in Europe more widely. This book teases out the similarities and differences between ‘the sweat’ and its better-known, if equally feared, contemporary infectious disease, bubonic plague.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Porter
      </h2>
      
      <p class="authorDescription body article">Stephen Porter was the author of numerous books on early modern disasters including fire, plague, and war. For many years he worked for the Survey of London, which records the history of London’s built environment. An acknowledged authority on London history, he was also an expert on the English civil wars. His books include The Great Fire, The Great Plague, Destruction in the English Civil Wars, The Tower of London, Shakespeare’s London, Pepys’s London, Everyday Life in Tudor London and Black Death. Stephen Porter was a Fellow of the Society of Antiquaries and of the Royal Historical Society. He died in 2021.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50bf3b92